var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61397 16.2862H3.8933L4.90227 15.2756H3.61397C3.28047 15.2756 3.00865 15.0037 3.00865 14.6693V10.3309C3.00865 9.99652 3.28047 9.7246 3.61397 9.7246H6.41508V13.7604L7.42405 12.7498V9.47424L12.1116 6.01141V8.05446L13.1206 7.04388V6.01108C13.1206 5.6277 12.9081 5.28191 12.5668 5.10934C12.2248 4.93644 11.8212 4.97043 11.5131 5.19824L6.7538 8.71369H3.61429C2.72442 8.71369 2 9.43927 2 10.3306V14.669C2 15.5606 2.7241 16.2862 3.61397 16.2862Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1423 5.14855C16.9452 4.95114 16.6261 4.95114 16.429 5.14855L2.46228 19.1375C2.26518 19.3349 2.26518 19.6548 2.46228 19.8519C2.56082 19.9506 2.69004 20 2.81894 20C2.94784 20 3.07706 19.9506 3.17561 19.8519L6.73606 16.2861H6.75368L11.513 19.8019C11.6905 19.9333 11.9 20 12.1112 20C12.2662 20 12.4218 19.9637 12.5667 19.8908C12.9084 19.7176 13.1205 19.3718 13.1205 18.9884V9.89127L17.1423 5.86301C17.3394 5.6656 17.3394 5.34563 17.1423 5.14855ZM12.1115 18.9884L7.46473 15.556L12.1115 10.9018V18.9884Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/Volume-Mute.996c95890f672eab05c7ebafd3334932.svg";
export { ForwardRef as ReactComponent };